import { render, staticRenderFns } from "./MyPaymentsTableMobile.vue?vue&type=template&id=11851364&scoped=true"
import script from "./MyPaymentsTableMobile.vue?vue&type=script&lang=js"
export * from "./MyPaymentsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./MyPaymentsTableMobile.vue?vue&type=style&index=0&id=11851364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11851364",
  null
  
)

export default component.exports